import { all, takeEvery, put, fork, call, race } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { push } from 'react-router-redux';
import axios from 'axios';
import isFunction from 'lodash/isFunction';
import _ from 'lodash';

import { getToken } from '../../helpers/utility';
import actions from './actions';
import { APIError } from '../../customApp/errors';

import { API_HOST, ERROR_CODE_TIMEOUT, API_STATUS_CODE_SUCCESS } from '../../customApp/constants';
import { handleError } from '../../customApp/errorHandler';

import { basePath } from '../../v2/baseRouter';

const LOGIN_API_URL = 'api/user/login';

function* loginRequest() {
  yield takeEvery(actions.LOGIN_REQUEST, function* (payload) {
    const { username, password, recaptchaToken, onSuccess } = payload;
    try {
      const { timeout, res } = yield race({
        res: call([axios, 'post'], `${API_HOST}/${LOGIN_API_URL}`, {
          account: username,
          password,
          recaptchaToken,
        }),
        timeout: call(delay, 10000),
      });
      if (timeout) {
        throw new APIError(ERROR_CODE_TIMEOUT, '連線逾時');
      }
      if (res.data.status_code !== API_STATUS_CODE_SUCCESS) {
        throw new APIError(res.data.message, res.data.status_code);
      }
      const { data } = res.data;
      yield put({
        type: actions.LOGIN_SUCCESS,
        apiToken: data.api_token,
        permissions: JSON.stringify(data.permission),
        brandIdSetting: data.brand_id_setting,
        user: JSON.stringify(data.user),
        roles: data.role,
        onSuccess,
      });
    } catch (error) {
      yield handleError(error);
    }
  });
}

function setPermissionsToSessionStorage(permissions) {
  const mutatedPermissions = JSON.parse(permissions);
  sessionStorage.setItem('permissions', permissions);
  _.forIn(mutatedPermissions, (permissionsOfModule, moduleName) => {
    sessionStorage.setItem(`permission.${moduleName}`, JSON.stringify(permissionsOfModule));
  });
  return '';
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield sessionStorage.setItem('api_token', payload.apiToken);
    yield sessionStorage.setItem('user', payload.user);
    yield sessionStorage.setItem('roles', payload.roles);
    yield sessionStorage.setItem('brand_id_setting', payload.brandIdSetting);
    yield call(setPermissionsToSessionStorage, payload.permissions);
    const { onSuccess } = payload;
    const onLoginSuccess = isFunction(onSuccess) ? onSuccess : () => {};
    yield call(onLoginSuccess);
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* (payload) {
    yield handleError(payload.error);
  });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    sessionStorage.clear();
    yield put(push(basePath));
  });
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
    const apiToken = getToken().get('apiToken');
    try {
      const user = sessionStorage.getItem('user');
      const roles = sessionStorage.getItem('roles');
      const permissions = sessionStorage.getItem('permissions');
      const brandIdSetting = sessionStorage.getItem('brand_id_setting');
      if (apiToken) {
        yield put({
          type: actions.LOGIN_SUCCESS,
          apiToken,
          user,
          roles,
          permissions,
          brandIdSetting,
          profile: 'Profile',
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOING_ERROR,
        error,
      });
    }
  });
}
export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
  ]);
}
